<template>
  <div  style="position: relative;">
    <v-carousel
        :height="$vuetify.breakpoint.lgAndUp?'86vh':'auto'"
        hide-delimiter-background
        hide-delimiters
        :show-arrows="false"
        v-model="selectedImage"
        cycle
    >
      <v-carousel-item
          v-for="(item, i) in sliderItems"
          :key="i"

      >
        <v-img class="" :src="item.photo_file" style="object-fit: fill" cover></v-img>
      </v-carousel-item>
    </v-carousel>
    <div class="dots-box-position d-flex flex-row justify-center align-center ">
      <v-row>
        <v-col class="d-flex justify-center align-center">
          <div
              @click="selectedImage = index"
              class="d-flex flex-column justify-center align-center ma-2"
              :style="{'height': '12px','width': '12px', 'background-color':selectedImage===index?$route.path.indexOf('light-blocks')>0? '#7BAD32':'#25458c':'rgba(204,204,204,0.27)'}"
              v-for="(item,index) in sliderItems" :key="index">
          </div>
        </v-col>
      </v-row>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "TopSlider",
  data() {
    return {
      selectedImage: 0,
      stop: false,
    }
  },
  props: {
    sliderItems: {
      
    }
  },
  methods: {
    checkedBottomItem() {
      return this.sliderItems[this.sliderItems.length - 1].id === this.sliderItems[this.selectedImage].id
    },

    slideLoop() {

      if (this.checkedBottomItem()) {
        this.selectedImage = 0
      } else {
        this.selectedImage++;
      }
      setTimeout(() => this.paused(), 1000);
      setTimeout(() => this.resume(), 2000);
    },
    paused() {
      this.stop = true;
    },
    resume() {
      this.stop = false;
    },
    currentImage() {
      switch (this.selectedImage) {
        case 0:
          return 'slide-1';
        case 1:
          return 'slide-2';
        case 2:
          return 'slide-3';
        default:
          return 'slide-4';
      }
    },

  },

  created() {
    setInterval(() => this.slideLoop(), 4000);

  },
}
</script>

<style scoped>

.slide-1 {
  height: 80vh;
  width: 100vw;
  background: url("../../assets/images/home-slider/9.jpg") center no-repeat;
  background-size: cover;
}

.slide-2 {
  height: 80vh;
  width: 100vw;
  background: url("../../assets/images/home-slider/1.jpg") center no-repeat;
  background-size: cover;
}

.slide-3 {
  height: 80vh;
  width: 100vw;
  background: url("../../assets/images/home-slider/2.jpg") center no-repeat;
  background-size: cover;
}

.slide-4 {
  height: 80vh;
  width: 100vw;
  background: url("../../assets/images/home-slider/12.jpg") center no-repeat;
  background-size: cover;
}

.slide-img {
  position: relative;
  transition: background 8s;
  height: 90vh;
}


.dots-box-position {
  position: absolute;
  bottom: 30px;
  right: 0;
  left: 0;
  height: 60px;
}

.slider {
  background-color: rgba(8, 70, 190, 0.44);
  height: 100%;
  z-index: 9999;
  animation-play-state: paused;
  animation: skew ease-in infinite;

}

@keyframes skew {
  from {
    width: 0
  }
  to {
    width: 100%
  }

}

.paused {
  animation-play-state: paused;
  animation-duration: 4s;
}

.resumed {
  animation-play-state: running;
  animation-duration: 4s;
}
</style>